import styled from 'styled-components';
import { ASSETS } from '../../../assets';

export const Icon = styled(ASSETS.HOURGLASS)`
  width: 21px;
  height: 32.7px;
`;
